module.exports = __webpack_public_path__ + "static/img/responsive.e41de508.svg";